import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { DateService, IDateFormatOptions } from "@services/date.service";

@Pipe({
    name: 'vDate',
    pure: true
})
@Injectable()
export class VDatePipe implements PipeTransform {
    constructor(private dateService: DateService) {
         
    }

    transform(input: string, options: IDateFormatOptions): string {
        return this.dateService.formatDate(input, options);
    }
}
